import React from 'react';

const MeetTheBoard = () => {
  const boardMembers = [
    {
      name: 'Eleanor Vance',
      title: 'Chairperson',
      bio: 'A lifelong patron of the arts, Eleanor has dedicated over 20 years to fostering community engagement in ballet. Her leadership is guided by a deep love for dance and a commitment to artistic excellence.',
      imageUrl: 'img/Ballet-Idaho.-Photo-Credit-Mike-Reid-750x450.jpg'
    },
    {
      name: 'Marcus Thorne',
      title: 'Vice Chairperson',
      bio: 'With a strong background in finance and strategic planning, Marcus ensures the fiscal health and long-term sustainability of the Northwest Ballet Theater. He is passionate about making ballet accessible to all.',
      imageUrl: 'img/brand_PNB_Nutcracker21-3fe58a9c56.webp'
    },
    {
      name: 'Isabella Rossi',
      title: 'Secretary',
      bio: 'Isabella is a former professional ballerina and brings a wealth of artistic experience to the board. She is dedicated to preserving the classical traditions of ballet while embracing contemporary innovation.',
      imageUrl: 'img/c380694c-47e2-4dca-a925-f6dba49bb608_750x422.jpg'
    },
    {
      name: 'Julian Croft',
      title: 'Treasurer',
      bio: "As a certified public accountant, Julian oversees the organization\'s budget and financial reporting. His meticulous approach and dedication are vital to our success.",
      imageUrl: 'img/d5c8b48e0b691906e71f550d6ecd76ce.avif'
    },
    {
      name: 'Clara Chen',
      title: 'Director of Community Outreach',
      bio: 'Clara works to build strong relationships with local schools and community organizations. She believes in the transformative power of dance and strives to share it with the widest possible audience.',
      imageUrl: 'img/f3a1fc9f-3279-4203-bddb-c626f1dc73d6_3300x2201.jpg'
    },
    {
      name: 'Samuel Greene',
      title: 'Director of Development',
      bio: 'Samuel leads our fundraising and development efforts. His passion for connecting patrons with our mission helps secure the resources needed to bring world-class ballet to our community.',
      imageUrl: 'img/GiselleLESLEY_0933_turkog.webp'
    },
  ];

  return (
    <div className="container-custom py-12">
      <h1 className="text-4xl font-bold font-elegant text-ballet-burgundy mb-4 text-center">Meet the Board</h1>
      <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto">
        Our Board of Directors is composed of dedicated community leaders, philanthropists, and arts advocates who volunteer their time and expertise to guide the Northwest Ballet. Their commitment ensures a sustainable future for our theater and academy.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {boardMembers.map((member, index) => (
          <div key={index} className="bg-white rounded-lg shadow-elegant p-6 text-center transform hover:scale-105 transition-transform duration-300">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="w-32 h-32 rounded-full mx-auto mb-4 border-4 border-ballet-pink"
            />
            <h3 className="text-2xl font-elegant text-ballet-burgundy font-semibold">{member.name}</h3>
            <p className="text-md font-bold text-gray-600 mb-2">{member.title}</p>
            <p className="text-gray-700 text-sm">{member.bio}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetTheBoard;
